import { render, staticRenderFns } from "./OurPartner.vue?vue&type=template&id=83188a8e&"
import script from "./OurPartner.vue?vue&type=script&lang=js&"
export * from "./OurPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports